// Location: assets/banner-logo-overlay.js
// What: Position the banner background overlay slightly above its responsive logo.
// Why: Follow merchant logo placement without whitening the logo or caption.
// RELEVANT FILES: sections/image-banner.liquid, assets/section-image-banner.css, snippets/banner-bottom-logo.liquid
if (!customElements.get('banner-logo-overlay')) {
  customElements.define('banner-logo-overlay', class extends HTMLElement {
    connectedCallback() {
      this.banner = this.closest('.banner');
      this.logo = this.banner?.querySelector('.banner__brand-logo');
      if (!this.logo) return;
      this.update = () => {
        const bannerBounds = this.banner.getBoundingClientRect();
        const logoBounds = this.logo.getBoundingClientRect();
        const scale = bannerBounds.height / this.banner.offsetHeight || 1;
        const top = Math.max(0, Math.min(this.banner.offsetHeight, (logoBounds.top - bannerBounds.top) / scale - 24));
        this.style.setProperty('--logo-overlay-top', `${top}px`);
      };
      this.observer = new ResizeObserver(this.update);
      [this.banner, this.logo, this.logo.parentElement].forEach(element => this.observer.observe(element));
      this.logo.addEventListener('load', this.update);
      this.banner.addEventListener('animationend', this.update);
      this.banner.addEventListener('transitionend', this.update);
      window.addEventListener('resize', this.update);
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.logo?.removeEventListener('load', this.update);
      this.banner?.removeEventListener('animationend', this.update);
      this.banner?.removeEventListener('transitionend', this.update);
      window.removeEventListener('resize', this.update);
    }
  });
}
